module.exports = __webpack_public_path__ + "MOORE_LOGO-841abec176853a4cb7ac6f44ea86ebe2.png";